export interface AuthDebugState {
  updatedAt: string;
  stage: string;
  host?: string;
  path?: string;
  userAgent?: string;
  firebaseUid?: string | null;
  firebaseEmail?: string | null;
  errorCode?: string;
  errorMessage?: string;
  detail?: string;
}

const STORAGE_KEY = "kga_auth_debug";

function canUseStorage(): boolean {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function writeAuthDebug(
  stage: string,
  updates: Partial<AuthDebugState> = {}
): void {
  if (!canUseStorage()) {
    return;
  }

  const nextState: AuthDebugState = {
    updatedAt: new Date().toISOString(),
    stage,
    host: window.location.host,
    path: `${window.location.pathname}${window.location.search}`,
    userAgent: window.navigator.userAgent,
    ...updates
  };

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextState));
}

export function readAuthDebug(): AuthDebugState | null {
  if (!canUseStorage()) {
    return null;
  }

  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as AuthDebugState;
  } catch {
    return null;
  }
}

export function clearAuthDebug(): void {
  if (!canUseStorage()) {
    return;
  }

  window.localStorage.removeItem(STORAGE_KEY);
}
